import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";

const SystemTray = (props) => {

  const [buildNumber, setBuildNumber] = useState();

  useEffect(() => {
    fetch('/version.txt')
      .then(response => {
        const contentType = response.headers.get('Content-Type');

        if (!response.ok || !contentType.includes("text/plain")) {
          return '';
        }
        return response.text()
      })
      .then(buildNumber => setBuildNumber(buildNumber.replace('uat-rc-', '')))
  }, [])

    return (
      <div id="system-tray">
        <Icon name="user" color="grey" /> {props.logIn.name}
        <span className="float-right">
          <Icon name="building" color="grey" /> {props.logIn.companyName}
          <span className="version">
            Version {props.logIn.version} {buildNumber ? `#${buildNumber}` : ''}
          </span>
        </span>
      </div>
    );
}

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, null)(SystemTray);
